export const comments_3411660 = {"data":{"data":[],"links":{}}}